import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from '../../../../security/service-app.service';
import { IFiltros, ITotaisHistorico } from '../interface-apuracao-vdm-acessorio';
import { ApuracaoVdmAcessorioService } from '../apuracao-vdm-acessorio.service';

@Component({
  selector: 'app-apuracao-vdm-acessorio-historico-jaguar',
  templateUrl: './apuracao-vdm-acessorio-historico-jaguar.component.html',
  styleUrls: ['./apuracao-vdm-acessorio-historico-jaguar.component.scss']
})
export class ApuracaoVdmAcessorioHistoricoJaguarComponent implements OnInit {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean = true;

  totaisHistorico: ITotaisHistorico = {
    filtroAno: 0,
    totalAbrObjSpnv: 0,
    totalAbrPercent: 0,
    totalAbrSpnvRealizado: 0,
    totalAbrVeiculosVista: 0,
    totalAbrVendaAcessorio: 0,
    totalMaiObjSpnv: 0,
    totalMaiPercent: 0,
    totalMaiSpnvRealizado: 0,
    totalMaiVeiculosVista: 0,
    totalMaiVendaAcessorio: 0,
    totalJunObjSpnv: 0,
    totalJunPercent: 0,
    totalJunSpnvRealizado: 0,
    totalJunVeiculosVista: 0,
    totalJunVendaAcessorio: 0,
    totalQ1ObjSpnv: 0,
    totalQ1Percent: 0,
    totalQ1SpnvRealizado: 0,
    totalQ1VeiculosVista: 0,
    totalQ1VendaAcessorio: 0,
    totalJulObjSpnv: 0,
    totalJulPercent: 0,
    totalJulSpnvRealizado: 0,
    totalJulVeiculosVista: 0,
    totalJulVendaAcessorio: 0,
    totalAgoObjSpnv: 0,
    totalAgoPercent: 0,
    totalAgoSpnvRealizado: 0,
    totalAgoVeiculosVista: 0,
    totalAgoVendaAcessorio: 0,
    totalSetObjSpnv: 0,
    totalSetPercent: 0,
    totalSetSpnvRealizado: 0,
    totalSetVeiculosVista: 0,
    totalSetVendaAcessorio: 0,
    totalQ2ObjSpnv: 0,
    totalQ2Percent: 0,
    totalQ2SpnvRealizado: 0,
    totalQ2VeiculosVista: 0,
    totalQ2VendaAcessorio: 0,
    totalOutObjSpnv: 0,
    totalOutPercent: 0,
    totalOutSpnvRealizado: 0,
    totalOutVeiculosVista: 0,
    totalOutVendaAcessorio: 0,
    totalNovObjSpnv: 0,
    totalNovPercent: 0,
    totalNovSpnvRealizado: 0,
    totalNovVeiculosVista: 0,
    totalNovVendaAcessorio: 0,
    totalDezObjSpnv: 0,
    totalDezPercent: 0,
    totalDezSpnvRealizado: 0,
    totalDezVeiculosVista: 0,
    totalDezVendaAcessorio: 0,
    totalQ3ObjSpnv: 0,
    totalQ3Percent: 0,
    totalQ3SpnvRealizado: 0,
    totalQ3VeiculosVista: 0,
    totalQ3VendaAcessorio: 0,
    totalJanObjSpnv: 0,
    totalJanPercent: 0,
    totalJanSpnvRealizado: 0,
    totalJanVeiculosVista: 0,
    totalJanVendaAcessorio: 0,
    totalFev2ObjSpnv: 0,
    totalFevPercent: 0,
    totalFevSpnvRealizado: 0,
    totalFevVeiculosVista: 0,
    totalFevVendaAcessorio: 0,
    totalMarObjSpnv: 0,
    totalMarPercent: 0,
    totalMarSpnvRealizado: 0,
    totalMarVeiculosVista: 0,
    totalMarVendaAcessorio: 0,
    totalQ4ObjSpnv: 0,
    totalQ4Percent: 0,
    totalQ4SpnvRealizado: 0,
    totalQ4VeiculosVista: 0,
    totalQ4VendaAcessorio: 0
  }

  @Input() filtros: IFiltros;
  @ViewChild('dt') dt: Table;
  constructor(private service: ServiceAppService, private apuracaoVdmAcessorioService: ApuracaoVdmAcessorioService) { }

  ngOnInit(): void {
    // Dados serão carregados pelo componente pai
    this.cols = [
      { field: 'codDealer', header: 'Dealer', width: 'width:120px' },
      { field: 'nomeDealer', header: 'Nome', width: 'width:180px' },
      { field: 'abrObjSpnv', header: 'Obj SPNV / Abr', width: 'width:175px' },
      { field: 'abrVeiculosVista', header: 'Veículos vista / Abr', width: 'width:190px' },
      { field: 'abrVendaAcessorio', header: 'Vendas de acessório / Abr', width: 'width:235px' },
      { field: 'abrSpnvRealizado', header: 'SPNV Realizado / Abr', width: 'width:225px' },
      { field: 'abrPercent', header: '% / Abr', width: 'width:125px' },
      { field: 'maiObjSpnv', header: 'Obj SPNV / Mai', width: 'width:175px' },
      { field: 'maiVeiculosVista', header: 'Veículos vista / Mai', width: 'width:190px' },
      { field: 'maiVendaAcessorio', header: 'Vendas de acessório / Mai', width: 'width:235px' },
      { field: 'maiSpnvRealizado', header: 'SPNV Realizado / Mai', width: 'width:225px' },
      { field: 'maiPercent', header: '% / Mai', width: 'width:125px' },
      { field: 'junObjSpnv', header: 'Obj SPNV / Jun', width: 'width:175px' },
      { field: 'junVeiculosVista', header: 'Veículos vista / Jun', width: 'width:190px' },
      { field: 'junVendaAcessorio', header: 'Vendas de acessório / Jun', width: 'width:235px' },
      { field: 'junSpnvRealizado', header: 'SPNV Realizado / Jun', width: 'width:225px' },
      { field: 'junPercent', header: '% / Jun', width: 'width:125px' },
      { field: 'q1ObjSpnv', header: 'Obj SPNV / Q1', width: 'width:175px' },
      { field: 'q1VeiculosVista', header: 'Veículos vista / Q1', width: 'width:185px' },
      { field: 'q1VendaAcessorio', header: 'Vendas de acessório / Q1', width: 'width:230px' },
      { field: 'q1SpnvRealizado', header: 'SPNV Realizado / Q1', width: 'width:225px' },
      { field: 'q1Percent', header: '% / Q1', width: 'width:125px' },
      { field: 'julObjSpnv', header: 'Obj SPNV / Jul', width: 'width:175px' },
      { field: 'julVeiculosVista', header: 'Veículos vista / Jul', width: 'width:190px' },
      { field: 'julVendaAcessorio', header: 'Vendas de acessório / Jul', width: 'width:235px' },
      { field: 'julSpnvRealizado', header: 'SPNV Realizado / Jul', width: 'width:225px' },
      { field: 'julPercent', header: '% / Jul', width: 'width:125px' },
      { field: 'agoObjSpnv', header: 'Obj SPNV / Ago', width: 'width:175px' },
      { field: 'agoVeiculosVista', header: 'Veículos vista / Ago', width: 'width:192px' },
      { field: 'agoVendaAcessorio', header: 'Vendas de acessório / Ago', width: 'width:235px' },
      { field: 'agoSpnvRealizado', header: 'SPNV Realizado / Ago', width: 'width:225px' },
      { field: 'agoPercent', header: '% / Ago', width: 'width:125px' },
      { field: 'setObjSpnv', header: 'Obj SPNV / Set', width: 'width:175px' },
      { field: 'setVeiculosVista', header: 'Veículos vista / Set', width: 'width:190px' },
      { field: 'setVendaAcessorio', header: 'Vendas de acessório / Set', width: 'width:235px' },
      { field: 'setSpnvRealizado', header: 'SPNV Realizado / Set', width: 'width:225px' },
      { field: 'setPercent', header: '% / Set', width: 'width:125px' },
      { field: 'q2ObjSpnv', header: 'Obj SPNV / Q2', width: 'width:175px' },
      { field: 'q2VeiculosVista', header: 'Veículos vista / Q2', width: 'width:185px' },
      { field: 'q2VendaAcessorio', header: 'Vendas de acessório / Q2', width: 'width:230px' },
      { field: 'q2SpnvRealizado', header: 'SPNV Realizado / Q2', width: 'width:225px' },
      { field: 'q2Percent', header: '% / Q2', width: 'width:125px' },
      { field: 'outObjSpnv', header: 'Obj SPNV / Out', width: 'width:175px' },
      { field: 'outVeiculosVista', header: 'Veículos vista / Out', width: 'width:190px' },
      { field: 'outVendaAcessorio', header: 'Vendas de acessório / Out', width: 'width:235px' },
      { field: 'outSpnvRealizado', header: 'SPNV Realizado / Out', width: 'width:225px' },
      { field: 'outPercent', header: '% / Out', width: 'width:125px' },
      { field: 'novObjSpnv', header: 'Obj SPNV / Nov', width: 'width:175px' },
      { field: 'novVeiculosVista', header: 'Veículos vista / Nov', width: 'width:192px' },
      { field: 'novVendaAcessorio', header: 'Vendas de acessório / Nov', width: 'width:235px' },
      { field: 'novSpnvRealizado', header: 'SPNV Realizado / Nov', width: 'width:225px' },
      { field: 'novPercent', header: '% / Nov', width: 'width:125px' },
      { field: 'dezObjSpnv', header: 'Obj SPNV / Dez', width: 'width:175px' },
      { field: 'dezVeiculosVista', header: 'Veículos vista / Dez', width: 'width:190px' },
      { field: 'dezVendaAcessorio', header: 'Vendas de acessório / Dez', width: 'width:235px' },
      { field: 'dezSpnvRealizado', header: 'SPNV Realizado / Dez', width: 'width:225px' },
      { field: 'dezPercent', header: '% / Dez', width: 'width:125px' },
      { field: 'q3ObjSpnv', header: 'Obj SPNV / Q3', width: 'width:175px' },
      { field: 'q3VeiculosVista', header: 'Veículos vista / Q3', width: 'width:185px' },
      { field: 'q3VendaAcessorio', header: 'Vendas de acessório / Q3', width: 'width:230px' },
      { field: 'q3SpnvRealizado', header: 'SPNV Realizado / Q3', width: 'width:225px' },
      { field: 'q3Percent', header: '% / Q3', width: 'width:125px' },
      { field: 'janObjSpnv', header: 'Obj SPNV / Jan', width: 'width:175px' },
      { field: 'janVeiculosVista', header: 'Veículos vista / Jan', width: 'width:190px' },
      { field: 'janVendaAcessorio', header: 'Vendas de acessório / Jan', width: 'width:235px' },
      { field: 'janSpnvRealizado', header: 'SPNV Realizado / Jan', width: 'width:225px' },
      { field: 'janPercent', header: '% / Jan', width: 'width:125px' },
      { field: 'fevObjSpnv', header: 'Obj SPNV / Fev', width: 'width:175px' },
      { field: 'fevVeiculosVista', header: 'Veículos vista / Fev', width: 'width:190px' },
      { field: 'fevVendaAcessorio', header: 'Vendas de acessório / Fev', width: 'width:235px' },
      { field: 'fevSpnvRealizado', header: 'SPNV Realizado / Fev', width: 'width:225px' },
      { field: 'fevPercent', header: '% / Fev', width: 'width:125px' },
      { field: 'marObjSpnv', header: 'Obj SPNV / Mar', width: 'width:175px' },
      { field: 'marVeiculosVista', header: 'Veículos vista / Mar', width: 'width:192px' },
      { field: 'marVendaAcessorio', header: 'Vendas de acessório / Mar', width: 'width:235px' },
      { field: 'marSpnvRealizado', header: 'SPNV Realizado / Mar', width: 'width:225px' },
      { field: 'marPercent', header: '% / Mar', width: 'width:125px' },
      { field: 'q4ObjSpnv', header: 'Obj SPNV / Q4', width: 'width:175px' },
      { field: 'q4VeiculosVista', header: 'Veículos vista / Q4', width: 'width:190px' },
      { field: 'q4VendaAcessorio', header: 'Vendas de acessório / Q4', width: 'width:235px' },
      { field: 'q4SpnvRealizado', header: 'SPNV Realizado / Q4', width: 'width:225px' },
      { field: 'q4Percent', header: '% / Q4', width: 'width:125px' }
    ];
  }

  retornaDados() {
    // Este método não deve ser usado - dados vêm do componente pai
    console.warn('retornaDados() não deve ser chamado - dados vêm do componente pai');
  }

  /**
   * Método para atualizar dados vindos do componente pai
   */
  public atualizarDados(dados: any[], totais: any) {
    this.dados = dados;
    this.totaisHistorico = {
      filtroAno: totais.filtroAno,
      totalAbrObjSpnv: totais.totalAbrObjSpnv,
      totalAbrPercent: totais.totalAbrPercent,
      totalAbrSpnvRealizado: totais.totalAbrSpnvRealizado,
      totalAbrVeiculosVista: totais.totalAbrVeiculosVista,
      totalAbrVendaAcessorio: totais.totalAbrVendaAcessorio,
      totalMaiObjSpnv: totais.totalMaiObjSpnv,
      totalMaiPercent: totais.totalMaiPercent,
      totalMaiSpnvRealizado: totais.totalMaiSpnvRealizado,
      totalMaiVeiculosVista: totais.totalMaiVeiculosVista,
      totalMaiVendaAcessorio: totais.totalMaiVendaAcessorio,
      totalJunObjSpnv: totais.totalJunObjSpnv,
      totalJunPercent: totais.totalJunPercent,
      totalJunSpnvRealizado: totais.totalJunSpnvRealizado,
      totalJunVeiculosVista: totais.totalJunVeiculosVista,
      totalJunVendaAcessorio: totais.totalJunVendaAcessorio,
      totalQ1ObjSpnv: totais.totalQ1ObjSpnv,
      totalQ1Percent: totais.totalQ1Percent,
      totalQ1SpnvRealizado: totais.totalQ1SpnvRealizado,
      totalQ1VeiculosVista: totais.totalQ1VeiculosVista,
      totalQ1VendaAcessorio: totais.totalQ1VendaAcessorio,
      totalJulObjSpnv: totais.totalJulObjSpnv,
      totalJulPercent: totais.totalJulPercent,
      totalJulSpnvRealizado: totais.totalJulSpnvRealizado,
      totalJulVeiculosVista: totais.totalJulVeiculosVista,
      totalJulVendaAcessorio: totais.totalJulVendaAcessorio,
      totalAgoObjSpnv: totais.totalAgoObjSpnv,
      totalAgoPercent: totais.totalAgoPercent,
      totalAgoSpnvRealizado: totais.totalAgoSpnvRealizado,
      totalAgoVeiculosVista: totais.totalAgoVeiculosVista,
      totalAgoVendaAcessorio: totais.totalAgoVendaAcessorio,
      totalSetObjSpnv: totais.totalSetObjSpnv,
      totalSetPercent: totais.totalSetPercent,
      totalSetSpnvRealizado: totais.totalSetSpnvRealizado,
      totalSetVeiculosVista: totais.totalSetVeiculosVista,
      totalSetVendaAcessorio: totais.totalSetVendaAcessorio,
      totalQ2ObjSpnv: totais.totalQ2ObjSpnv,
      totalQ2Percent: totais.totalQ2Percent,
      totalQ2SpnvRealizado: totais.totalQ2SpnvRealizado,
      totalQ2VeiculosVista: totais.totalQ2VeiculosVista,
      totalQ2VendaAcessorio: totais.totalQ2VendaAcessorio,
      totalOutObjSpnv: totais.totalOutObjSpnv,
      totalOutPercent: totais.totalOutPercent,
      totalOutSpnvRealizado: totais.totalOutSpnvRealizado,
      totalOutVeiculosVista: totais.totalOutVeiculosVista,
      totalOutVendaAcessorio: totais.totalOutVendaAcessorio,
      totalNovObjSpnv: totais.totalNovObjSpnv,
      totalNovPercent: totais.totalNovPercent,
      totalNovSpnvRealizado: totais.totalNovSpnvRealizado,
      totalNovVeiculosVista: totais.totalNovVeiculosVista,
      totalNovVendaAcessorio: totais.totalNovVendaAcessorio,
      totalDezObjSpnv: totais.totalDezObjSpnv,
      totalDezPercent: totais.totalDezPercent,
      totalDezSpnvRealizado: totais.totalDezSpnvRealizado,
      totalDezVeiculosVista: totais.totalDezVeiculosVista,
      totalDezVendaAcessorio: totais.totalDezVendaAcessorio,
      totalQ3ObjSpnv: totais.totalQ3ObjSpnv,
      totalQ3Percent: totais.totalQ3Percent,
      totalQ3SpnvRealizado: totais.totalQ3SpnvRealizado,
      totalQ3VeiculosVista: totais.totalQ3VeiculosVista,
      totalQ3VendaAcessorio: totais.totalQ3VendaAcessorio,
      totalJanObjSpnv: totais.totalJanObjSpnv,
      totalJanPercent: totais.totalJanPercent,
      totalJanSpnvRealizado: totais.totalJanSpnvRealizado,
      totalJanVeiculosVista: totais.totalJanVeiculosVista,
      totalJanVendaAcessorio: totais.totalJanVendaAcessorio,
      totalFev2ObjSpnv: totais.totalFev2ObjSpnv,
      totalFevPercent: totais.totalFevPercent,
      totalFevSpnvRealizado: totais.totalFevSpnvRealizado,
      totalFevVeiculosVista: totais.totalFevVeiculosVista,
      totalFevVendaAcessorio: totais.totalFevVendaAcessorio,
      totalMarObjSpnv: totais.totalMarObjSpnv,
      totalMarPercent: totais.totalMarPercent,
      totalMarSpnvRealizado: totais.totalMarSpnvRealizado,
      totalMarVeiculosVista: totais.totalMarVeiculosVista,
      totalMarVendaAcessorio: totais.totalMarVendaAcessorio,
      totalQ4ObjSpnv: totais.totalQ4ObjSpnv,
      totalQ4Percent: totais.totalQ4Percent,
      totalQ4SpnvRealizado: totais.totalQ4SpnvRealizado,
      totalQ4VeiculosVista: totais.totalQ4VeiculosVista,
      totalQ4VendaAcessorio: totais.totalQ4VendaAcessorio,
    };
    this.loading = false;
  }
}